import React, { useState, useEffect } from "react";
import { useNotifications } from "./NotificationProvider";
import { Link, useNavigate } from "react-router-dom";
import { useChat } from "../../context/ChatContext";

const NotificationDropdown = () => {
  // Removed the notification prop
  const {
    notifications = [],
    unreadCount = 0,
    markAsRead,
    markAllAsRead,
    loading,
    error,
    connectionStatus,
  } = useNotifications();

  const [isOpen, setIsOpen] = useState(false);
  const [localNotifications, setLocalNotifications] = useState([]);

  const navigate = useNavigate();
  const { openChatWithReceiver } = useChat();
  const roleId = localStorage.getItem("roleId");

  // Debugging logs
  useEffect(() => {
    // console.log("Notifications from provider:", notifications);
    // console.log("Connection status:", connectionStatus);
  }, [notifications, connectionStatus]);

  // Improved state synchronization
  useEffect(() => {
    if (Array.isArray(notifications)) {
      setLocalNotifications([...notifications]);
    } else {
      console.warn("Notifications is not an array:", notifications);
      setLocalNotifications([]);
    }
  }, [notifications]);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".notification-dropdown-container")) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const toggleDropdown = () => {
    const newState = !isOpen;
    setIsOpen(newState);

    // if (newState && unreadCount > 0) {
    //   markAllAsRead();
    // }
  };

  const getNotificationIcon = (type) => {
    switch (type) {
      case "DirectMessage":
        return "💬";
      case "Mention":
        return "👤";
      case "Like":
        return "👍";
      default:
        return "🔔";
    }
  };

  const formatDate = (dateString) => {
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "Just now";

      return date.toLocaleString("en-US", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
    } catch {
      return "Just now";
    }
  };

  return (
    <div className="notification-dropdown-container position-relative">
      <div
        className="notification-indicator notification-indicator-primary cursor-pointer"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        aria-label="Notifications"
      >
        <i className="uil uil-bell fs-6 lh-1 text-primary"></i>
        {unreadCount > 0 && (
          <span className="notification-indicator-number badge bg-danger">
            {unreadCount > 9 ? "9+" : unreadCount}
          </span>
        )}
      </div>

      {isOpen && (
        <div className="dropdown-menu dropdown-menu-end notification-dropdown-menu py-0 shadow border navbar-dropdown-caret show">
          <div className="card position-relative border-0">
            <div className="card-header p-2">
              <div className="d-flex justify-content-between">
                <h5 className="text-body-emphasis mb-0">Notifications</h5>
                {/* {unreadCount > 0 && (
                  <button
                    className="btn btn-link p-0 fs-9 fw-normal"
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      markAllAsRead();
                    }}
                  >
                    Mark all as read
                  </button>
                )} */}
              </div>
            </div>
            <div className="card-body p-0">
              <div
                className="scrollbar-overlay"
                style={{ height: "27rem", overflowY: "auto" }}
              >
                {loading ? (
                  <div className="text-center py-4">
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div>
                ) : error ? (
                  <div className="text-center py-4 text-danger">{error}</div>
                ) : localNotifications.length === 0 ? (
                  <div className="text-center py-4">
                    <p>No notifications yet</p>
                  </div>
                ) : (
                  localNotifications
                    .filter((notification) => !notification.isRead)
                    .map((notification) => {
                      return (
                        <div
                          key={
                            notification.id ||
                            Math.random().toString(36).substr(2, 9)
                          }
                          className={`px-2 px-sm-3 py-3 notification-card position-relative ${
                            notification.isRead ? "read" : "unread"
                          }`}
                          onClick={() =>
                            notification.id && markAsRead(notification.id)
                          }
                        >
                          <div className="d-flex align-items-center justify-content-between position-relative">
                            <div className="d-flex">
                              <div className="avatar avatar-m status-online me-3 d-none">
                                <img
                                  className="rounded-circle"
                                  src={
                                    notification.senderAvatar ||
                                    "/image/team/avatar-placeholder.jpg"
                                  }
                                  alt={notification.senderName || "User"}
                                  onError={(e) => {
                                    e.target.src = "/image/team/1.jpg";
                                  }}
                                />
                              </div>
                              <div className="flex-1 me-sm-3">
                                {/* <h4 className="fs-9 text-body-emphasis">
                                {notification.senderName || "Admin"}
                              </h4> */}
                                <p className="fs-9 text-body-highlight mb-1 fw-normal">
                                  {/* <span className="me-1 fs-10">
                                  {getNotificationIcon(
                                    notification.notificationType
                                  )}
                                </span> */}
                                  {notification.message || "New notification"}
                                </p>
                                <p className="text-black-50 fs-9 mb-1 fs-10">
                                  {/* <span className="me-1 fas fa-clock"></span> */}
                                  <span className="fw-bold">
                                    {formatDate(notification.createdAt)}
                                  </span>
                                </p>
                                <div className="d-flex gap-1">
                                  <button
                                    className="btn btn-outline-primary p-1 px-2 fs-10"
                                    onClick={() => {
                                      setIsOpen(false);

                                      if (
                                        notification.targetUrl === "" &&
                                        notification.notificationType ===
                                          "adminParentChat"
                                      ) {
                                        openChatWithReceiver(
                                          ["9", "10", "11"].includes(roleId)
                                            ? notification.receiverId
                                            : notification.senderId
                                        );
                                      } else {
                                        navigate(notification.targetUrl);
                                        window.location.reload();
                                      }
                                    }}
                                  >
                                    See Details
                                  </button>
                                  <button
                                    className="btn btn-primary p-1 px-2 fs-10"
                                    onClick={() =>
                                      notification.id &&
                                      markAsRead(notification.id)
                                    }
                                  >
                                    Mark as Read
                                  </button>
                                </div>
                              </div>
                            </div>
                            {!notification.isRead && (
                              <div className="unread-dot"></div>
                            )}
                          </div>
                        </div>
                      );
                    })
                )}
              </div>
            </div>
            {(roleId == "2" || roleId == "3") && (
              <div class="card-footer p-2">
                <div class="d-flex justify-content-center">
                  <Link
                    to="/all-notifications"
                    onClick={() => setIsOpen(false)}
                  >
                    See All
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationDropdown;
